"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserFetching = exports.isLoggingIn = exports.loginErrors = exports.isLoggedIn = exports.authUser = exports.isRefreshing = exports.authTokens = void 0;

var _config = require("./config");

var authTokens = function authTokens(state) {
  return state[_config.reducerName].tokens;
};

exports.authTokens = authTokens;

var isRefreshing = function isRefreshing(state) {
  return state[_config.reducerName].isRefreshing;
};

exports.isRefreshing = isRefreshing;

var authUser = function authUser(state) {
  return state[_config.reducerName].user;
};

exports.authUser = authUser;

var isLoggedIn = function isLoggedIn(state) {
  return state[_config.reducerName].isLoggedIn;
};

exports.isLoggedIn = isLoggedIn;

var loginErrors = function loginErrors(state) {
  return state[_config.reducerName].loginError;
};

exports.loginErrors = loginErrors;

var isLoggingIn = function isLoggingIn(state) {
  return state[_config.reducerName].isLoggingIn;
};

exports.isLoggingIn = isLoggingIn;

var isUserFetching = function isUserFetching(state) {
  return state[_config.reducerName].isUserFetching;
};

exports.isUserFetching = isUserFetching;